import { Box, Typography } from "@mui/material";
import ButtonComponent from "../customButton";
import { NOT_FOUND_ICON_BOX_SX } from "./notFound.constants";

const ResourceNotFound = ({
    icon,
    title,
    message,
    actionLabel,
    onAction,
    variant = "panel",
}) => {
    const isDrawer = variant === "drawer";

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                alignSelf: "stretch",
                ...(isDrawer
                    ? { flex: 1, minHeight: "calc(100vh - 56px)", px: 3, alignSelf: "stretch" }
                    : { height: "100%", minHeight: "calc(100vh - 200px)" }),
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: 360,
                    width: "100%",
                    gap: 1.5,
                }}
            >
                {icon && (
                    <Box sx={{ ...NOT_FOUND_ICON_BOX_SX, mb: 0.5 }}>
                        {icon}
                    </Box>
                )}

                <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
                    {title}
                </Typography>

                <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", lineHeight: 1.6, maxWidth: 320 }}
                >
                    {message}
                </Typography>

                {actionLabel && onAction && (
                    <Box sx={{ mt: 1 }}>
                        <ButtonComponent
                            variant="primary"
                            ctaText={actionLabel}
                            className="bg-blue600 white"
                            onClick={onAction}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ResourceNotFound;
